var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ministry-breadcrumbs',{attrs:{"mainTitle":_vm.mainTitle,"breadcrumbs":_vm.breadcrumbs}}),_c('b-card',[_c('data-table',{attrs:{"fields":_vm.reqsFields,"ep":"v2/ministry/requests","id":"ngos-requests"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }